import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
  background-color: ${({ theme }) => theme.colors.white};
  position: sticky;
  top: 0;
  z-index: 1;
`;

export const CheckboxContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
`;

export const SearchBoxContainer = styled.div`
  flex: 1 1 40%;
  min-width: 200px;
`;

export const MilestoneTypeDropdownContainer = styled.div`
  flex: 0 0 200px;
  min-width: 200px;
`;

export const UnplanButtonContainer = styled.div`
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  white-space: nowrap;
`;
